import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

interface TooltipButtonProps {
  color?: string;
}

export default styled.button<TooltipButtonProps>`
  padding: 0;
  margin: 0;
  outline: none;
  border: none;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: ${({ color }) => color || "#ffffff"};
  background: transparent;
  align-self: center;

  @media screen and (min-width: ${DESKTOP}px) {
    cursor: pointer;
    vertical-align: text-top;
    align-self: flex-start;
  }
`;
